import { render, staticRenderFns } from "./CopyrightRow.vue?vue&type=template&id=bccc2f34&scoped=true&"
import script from "./CopyrightRow.vue?vue&type=script&lang=js&"
export * from "./CopyrightRow.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightRow.vue?vue&type=style&index=0&id=bccc2f34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccc2f34",
  null
  
)

export default component.exports